const messages: Record<string, string> = {
	'thanks.paragraph.first': 'спасибо за использование PolicyCheck!',
};

export default messages;
